import React, {useState} from 'react';
import HintContext from '../contexts/HintContext';

/**
 * Компонент обёртка. Предоставляет значение контекста HintContext
 */
export default function Hints({ children }) {
  const [hintObj, setHintObj] = useState();
  return <HintContext.Provider children={children} value={{hintObj: hintObj, setHint: setHintObj}} />
}